import { csx } from '@vtex/admin-ui'

export const styles = {
  content: csx({
    gridColumn: 'title / span 2',
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-1',
  }),
  icon: csx({
    alignItems: 'center',
    background: '$secondary',
    borderRadius: '100%',
    height: '2.5rem',
    width: '2.5rem',
  }),
  actions: csx({
    display: 'flex',
    alignItems: 'center',
  }),
}
